import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-arangers-list',
  templateUrl: './arangers-list.component.html',
  styleUrls: ['./arangers-list.component.scss']
})
export class ArangersListComponent implements OnInit {
  @Input() arangersList: Array<any>;
  localArrangerList: Array<any>;
  isMobile: boolean;

  constructor(private router: Router) {
    if (window.innerWidth <= 1025) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  ngOnInit(): void {
    this.localArrangerList = this.arangersList;
    const arrList = this.localArrangerList;
    arrList.forEach(arranger => {
      arranger.opened = false;
      arranger.showImage = false;
      const fullPath = arranger.user_details.img_path;
      if (fullPath != null) {
        const finalPath = fullPath.substr(fullPath.indexOf('/'), fullPath.length);
        arranger.imagePath = `${environment.avatarUrl}${finalPath}`;
      }
    });
    this.localArrangerList = arrList;
  }

  public togglePanelhandler(index, panel?) {
    const arrList = this.localArrangerList;

    if (arrList[index].opened) {
      panel?.close();
      arrList[index].showImage = false;
      arrList[index].opened = false;
    } else {
      panel?.open();
      arrList[index].opened = true;

      setTimeout(() => {
        arrList[index].showImage = true;
      }, 200);

      if (this.isMobile) {
        arrList.forEach((el, i) => {
          if (i !== index) {
            arrList[i].opened = false;
          }
        });
      }
    }

    this.localArrangerList = arrList;
  }

  public goToSearch(id: number) {
    this.router.navigate(['/szukaj'], { queryParams: { arranger: id } });
  }

}
